/**
 * Copyright © 2026 Delicious AI, LLC
 */

import { gql } from '@apollo/client'
import { SABRE_PRODUCT_MODEL_EXCLUSION_FRAGMENT } from '../fragments/ProductModelExclusionFragment'

export const SABRE_GET_PRODUCT_MODEL_EXCLUSION = gql`
  query GetProductModelExclusion($upc: String!) {
    product(upc: $upc) {
      ...ProductModelExclusion
    }
  }
  ${SABRE_PRODUCT_MODEL_EXCLUSION_FRAGMENT}
`
